export default {"src":"/_next/static/media/DB.57499ed9.svg","height":18,"width":18};